import { c as _c } from "react/compiler-runtime";
import { DropdownMenu, DropdownMenuContent, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@/components/ui/DropdownMenu';
import { Monitor, Moon, Sun } from '@/components/ui/icons/Icons';
import { useI18n } from '@/context/I18nProvider';
import { ThemePreference, useThemePreference } from '@/hooks/useThemePreference';
import { cn } from '@/lib/utils';
export const THEME_OPTIONS = [{
  value: 'light',
  icon: Sun,
  labelKey: 'theme.light'
}, {
  value: 'dark',
  icon: Moon,
  labelKey: 'theme.dark'
}, {
  value: 'system',
  icon: Monitor,
  labelKey: 'theme.system'
}] as const;

/** Light / Dark / System switch for the app header. */
const ThemeToggle = t0 => {
  const $ = _c(24);
  const {
    className
  } = t0;
  const {
    t
  } = useI18n();
  const {
    preference,
    resolvedTheme,
    setPreference
  } = useThemePreference();
  const Icon = resolvedTheme === "dark" ? Moon : Sun;
  let t1;
  if ($[0] !== t) {
    t1 = t("theme.label");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("theme.label");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== className) {
    t3 = cn("flex size-8 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground", className);
    $[4] = className;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== Icon) {
    t4 = <Icon className="size-4" />;
    $[6] = Icon;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <DropdownMenuTrigger asChild={true}><button type="button" aria-label={t1} title={t2} className={t3}>{t4}</button></DropdownMenuTrigger>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== setPreference) {
    t6 = value => setPreference(value as ThemePreference);
    $[13] = setPreference;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = THEME_OPTIONS.map(option => <DropdownMenuRadioItem key={option.value} value={option.value} className="gap-2"><option.icon className="size-4" />{t(option.labelKey)}</DropdownMenuRadioItem>);
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== preference || $[18] !== t6 || $[19] !== t7) {
    t8 = <DropdownMenuContent align="end" className="w-40"><DropdownMenuRadioGroup value={preference} onValueChange={t6}>{t7}</DropdownMenuRadioGroup></DropdownMenuContent>;
    $[17] = preference;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t5 || $[22] !== t8) {
    t9 = <DropdownMenu>{t5}{t8}</DropdownMenu>;
    $[21] = t5;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
export { ThemeToggle };